import { render } from "./PasswordResetConfirmForm.vue?vue&type=template&id=333fbaf0"
import script from "./PasswordResetConfirmForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirmForm.vue?vue&type=script&lang=js"

import "./PasswordResetConfirmForm.vue?vue&type=style&index=0&id=333fbaf0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg,QCardSection,QInput,QIcon,QCardActions,QBtn});
